/**
 * 与 CommonPermissions / hasPermissions 一致：permissions[groupIndex] 为位掩码，与 mask 做按位与判断。
 */
import permissionDef from './permission_def.js'

export const PERMISSION_SLOT_COUNT =
  permissionDef.reduce((m, r) => Math.max(m, r.value != null ? Number(r.value) : 0), 0) + 1

/**
 * @param {number[]|undefined|null} arr
 * @returns {number[]}
 */
export function normalizePermissions(arr) {
  const out = []
  for (let i = 0; i < PERMISSION_SLOT_COUNT; i++) {
    out[i] = arr && arr[i] != null ? Number(arr[i]) : 0
  }
  return out
}

/**
 * @param {number[]} permissions
 * @param {[number, number]} def [groupIndex, bitMask]
 */
export function hasPermBits(permissions, def) {
  const idx = def[0]
  const mask = def[1]
  return ((permissions[idx] || 0) & mask) !== 0
}

/**
 * @param {number[]|undefined|null} permissions
 * @param {[number, number]} def
 * @param {boolean} checked
 * @returns {number[]}
 */
export function setPermBits(permissions, def, checked) {
  const next = normalizePermissions(permissions)
  const idx = def[0]
  const mask = def[1]
  if (checked) {
    next[idx] = (next[idx] || 0) | mask
  } else {
    next[idx] = (next[idx] || 0) & ~mask
  }
  return next
}
